import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import "bulma/css/bulma.css";

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(axios);

import Home from "./pages/Home.vue";
import ResourceList from "./pages/ResourceList.vue";
import Resource from "./pages/Resource.vue";

const routes = [
  { path: "/", name: "home", component: Home },
  { path: "/resources", name: "resources", component: ResourceList },
  {
    path: "/resource/:id",
    name: "resource",
    component: Resource,
    props: true
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

new Vue({
  router
}).$mount("#app");
